// Phase 6 — Track B T-B5. Dashboard copy.
// Phase 7.5 D3 — Track C T-C5. Adds seed-action copy for the empty-state
// pivot: when a count card renders zero, swap the bare 0 for an actionable
// link instead.

export const dashboardCopy = {
  navLabel: 'Home',
  pageTitle: 'Home',
  pageSubtitle: 'Your day at a glance.',
  emptyTitle: 'No cards yet',
  emptyBody: 'Enable a module to start seeing cards here.',
  loadingLabel: 'Loading your dashboard',
  errorTitle: 'Could not load your dashboard',
  errorBody: 'Try again in a moment.',
  retry: 'Retry',

  // Phase 7.5 D3 — empty-state pivot copy. Triggered when a count card
  // surfaces value === 0; the bare zero is replaced with a seed-action
  // link routed by the typed `cardId` (not the localised title).
  emptyAffordances: {
    connectGmailOrAddPayment: 'Connect Gmail or add a manual payment',
    uploadStatement: 'Upload a statement',
    addDate: 'Add a date',
  },
} as const;
